/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  children: React.ReactNode;
  onClickOk?: () => void | undefined;
  /** 「OK」ボタンが押下された時に閉じるか否か。 */
  doCloseOnClickOkButton?: undefined | boolean;
}

/**
 * OK ボタンが表示されたモーダル
 * @param param0
 * @returns
 */
function OkModal({ children, onClickOk, doCloseOnClickOkButton }: Props) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <Modal
      active={
        (typeof doCloseOnClickOkButton === 'boolean') ?
          (
            (doCloseOnClickOkButton) ?
              // doCloseOnClickOkButton が true の場合、「OK」ボタン押下で閉じる。
              isOpen
              :
              // doCloseOnClickOkButton に明確に false を渡されていた場合、常に表示。このダイアログ自体を描画するか否かの決定は外部で行う。
              true
          )
          :
          // doCloseOnClickOkButton が undefined の場合。
          (
            // onClickOk が prop で渡されていれば、表示する。このダイアログ自体を描画するか否かの決定は外部で行う。
            (typeof onClickOk === 'function')
            ||
            // onClickOk が undefined であれば、「OK」ボタン押下で閉じる。
            isOpen
          )
      }
      additionalClassName="popupfr340"
      displayCloseButton={false}
      onClose={() => {
        /* do nothing */
      }}
    >
      {children}
      <div className="mt10 mb0 center">
        <input
          type="button"
          className="red-button"
          value={t('OK').toString()}
          onClick={
            () => {
              if (typeof onClickOk === 'function') {
                onClickOk();
              }

              if (
                (doCloseOnClickOkButton)
                ||
                (typeof onClickOk !== 'function')
              ) {
                setIsOpen(false);
              }
            }
          }
        />
      </div>
    </Modal>
  );
}

OkModal.defaultProps = {
  onClickOk: undefined,
  doCloseOnClickOkButton: undefined,
};

export default OkModal;
